"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var TableRow_1 = __importDefault(require("atomicComponents/atoms/Table/TableRow"));
var LastCell_1 = __importDefault(require("atomicComponents/molecules/Table/LastCell"));
var Money_1 = __importDefault(require("components/Money"));
var ServiceCell_1 = __importDefault(require("containers/MyStack/styles/ServiceCell"));
var NoTeamRowDetails = function (_a) {
    var spend = _a.spend, toolsCount = _a.toolsCount, isPartialView = _a.isPartialView;
    return ((0, jsx_runtime_1.jsxs)(TableRow_1.default, __assign({ isClickable: true, style: { color: 'neutral.contrastText', cursor: 'default' } }, { children: [(0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ width: 200, flex: "none", sx: { pl: 1.75 } }, { children: "Tools without a team" })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ width: 125, textAlign: "right", flex: "none", hidden: isPartialView }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: spend || 0, isRounded: true }) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ textAlign: "right", hidden: isPartialView, sx: { pr: 0.75 } }, { children: toolsCount !== null && toolsCount !== void 0 ? toolsCount : 'N/A' })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, {}), (0, jsx_runtime_1.jsx)(LastCell_1.default, {})] })));
};
exports.default = NoTeamRowDetails;
